/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formfields_Middlename2Inputs */

const en_formfields_middlename2 = /** @type {(inputs: Formfields_Middlename2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Middle name`)
};

/**
* | output |
* | --- |
* | "Middle name" |
*
* @param {Formfields_Middlename2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const formfields_middlename2 = /** @type {((inputs?: Formfields_Middlename2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formfields_Middlename2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_formfields_middlename2(inputs)
});
export { formfields_middlename2 as "formFields_middleName" }